import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  LinearProgress,
  Typography,
  makeStyles,
  withStyles,
} from '@material-ui/core';
// import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';

const styledBy = property => props => props[property];

const ReportScoreBar = withStyles(theme => ({
  root: {
    height: 25,
    borderRadius: 8,
    backgroundColor: theme.palette.grey[300],
  },
  bar: {
    borderRadius: 8,
    background: styledBy('barColor'),
  },
}))(({ barColor, ...other }) => (
  <LinearProgress variant="determinate" {...other} />
));

const useStyles = makeStyles(() => ({
  reportName: {
    fontSize: 19,
    display: 'flex',
    alignItems: 'center',
    '& > svg': {
      fontSize: 20,
      marginLeft: 5,
      cursor: 'pointer',
    },
  },
  rowScoreText: {
    fontWeight: 'bold',
    color: '#8898aa',
  },
}));

const gradientColors = ['#d23333', '#d4532e', '#d77429', '#d99425', '#dbb420',
  '#ddd41b', '#bec625', '#9fb92e', '#7fab38', '#609d41', '#418f4a',
]; // the same as in gradient

function ReportScoreRow(props) {
  const {
    score, maxScore, buttonOnClick, buttonText,
  } = props;
  const classes = useStyles();

  const scoreBarValue = (score * 100) / maxScore;
  const colorIndex = Math.round((score / maxScore) * 10) - 1;

  const barColor = gradientColors[colorIndex];

  return (
    <Grid container justifyContent="center" spacing={3} style={{ padding: 0 }}>
      <Grid item xs={buttonOnClick ? 10 : 12}>
        <Grid container alignItems="center">
          <Grid item xs={10}>
            <Typography className={classes.reportName} variant="subtitle1">
              <span>{props.reportName}</span>
              {/* <HelpOutlineOutlinedIcon /> */}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography className={classes.rowScoreText} variant="h6" align="right">
              {score}
              /
              {maxScore}
            </Typography>
          </Grid>
          <Grid className="my-1" item xs={12}>
            <ReportScoreBar value={scoreBarValue} barColor={barColor} />
          </Grid>
        </Grid>
      </Grid>

      {buttonOnClick && (
        <Grid className="d-flex align-items-center" item xs={2} style={{ display: 'grid', alignItems: 'end' }}>
          <Button
            style={{ textTransform: 'none' }}
            onClick={buttonOnClick}
            variant="outlined"
          >
            {buttonText || 'More info'}
          </Button>
        </Grid>
      )}
    </Grid>
  );
}

ReportScoreRow.defaultProps = {
  buttonOnClick: undefined,
  buttonText: undefined,
  maxScore: 10,
};

ReportScoreRow.propTypes = {
  reportName: PropTypes.string.isRequired,
  score: PropTypes.number.isRequired, // must be less than `maxScore`
  buttonOnClick: PropTypes.func,
  buttonText: PropTypes.string,
  maxScore: PropTypes.number,
};

export default ReportScoreRow;
